import { render } from "./SignupView.vue?vue&type=template&id=4ae65b0d"
const script = {}
script.render = render

export default script